import React, { useState, useEffect } from "react";

const RotatingMessages = () => {
  const messages = [
    "Unlock your creativity and shape your ideas with powerful mind mapping tools.",
    "Make learning fun and engaging with interactive, visually appealing mind maps.",
    "Transform your concepts into well-structured documents effortlessly with IdeaMapper.",
    "Empower professionals with diverse thinking styles through innovative mind mapping.",
    "Boost student performance, creativity, and output with IdeaMapper.",
    "From brainstorming to structured writing, IdeaMapper simplifies your workflow.",
    "Enhance productivity and streamline your ideas, whether you're a student or a professional.",
    "Turn your thoughts into action with intuitive visual learning tools.",
    "Mind mapping made easy—fueling creativity for students, educators, and professionals alike.",
    "Discover how IdeaMapper transforms complex ideas into clear, organized documents.",
    "Revolutionize your learning process with engaging, interactive mind maps.",
    "Simplify your projects and boost creativity with powerful brainstorming tools.",
    "From classroom to boardroom, IdeaMapper helps you map out success.",
    "IdeaMapper: Where visual learning meets structured writing.",
    "Navigate your academic and professional journey with tools designed to unlock your full potential.",
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % messages.length);
        setFade(true);
      }, 500);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <p className={`rotating-text ${fade ? "fade-in" : "fade-out"}`}>
      {messages[currentIndex]}
    </p>
  );
};

export default React.memo(RotatingMessages);
